import {FC, useCallback, useEffect, useMemo, useRef, useState} from "react";
import 'moment/locale/ru'
import { NotificationRoot } from "./styles";
import { useNotificationContext } from "../../contexts/NotificationContext";
import {NotificationComponentController} from "./NotificationComponents/NotificationComponentController";
import {NotificationTypes} from "./const/const";
import { AppTester } from "supporting";
import { useToasts } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { Endpoints } from "@brg/api";

const NotificationListItem: FC<{ item: any }> = ({item}) => {

  const {
    notificationId,
    initiator: initiatorTop,
    isDelivered,
    actions
  } = item;

  const [ notificationData ] = actions;
  const { description, entityName } = notificationData;

  const { readNotification, readLocally } = useNotificationContext();
  const [isReadLocally, setIsReadLocally] = useState(isDelivered);
  const ref = useRef();

  const { error, info } = useToasts()
  const { t } = useTranslation()
  

  const firstLike = actions[0]?.likeInfo;
  const isPrint = actions[0]?.type === NotificationTypes.SEND_FILE;

  const isRead = isReadLocally || isDelivered || readLocally[notificationId];
  const isNew = useMemo(() =>(!isDelivered), [isDelivered])
  const isImportantNots = useMemo(() => (!firstLike && !isPrint), [firstLike, isPrint])
  const isHSEDesign = AppTester.isHSEDesign()
  const isCGRAVE = AppTester.isCGRAVE();
  const isSuperPuper = AppTester.isSuperPuper();
  const isDvaDesign = AppTester.isDvaDesign()
  const isGeograffee = AppTester.isGeograffee()
  const isGreenAward = AppTester.isGreenAward()
  const isDafes = AppTester.isGeoDafes()
  const isJhonata = AppTester.isJhonataNet()

  const handleDownload = (uploadUrl: string) => {
    info(t('print_project_save'))
    fetch(uploadUrl, { method: 'GET' })
        .then(resp => resp.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `${entityName}.pdf`
            document.body.appendChild(a);
            a.click();
            //@ts-ignore
            a = undefined
        })
        .catch((err: any) => {
            console.log('print_error_message', err)
            error(t('print_error_message'))
        })
  }

  const handleClick = useCallback(() => {
    if (isPrint) {
      const partLink = notificationData.textParts.find((part: any) => part.linkType === 'downloadFile')?.link
      const uploadUrl = `${Endpoints.files}/${partLink}`
      handleDownload(uploadUrl)
    }
    
    if (!isRead) {
      setIsReadLocally(true);
      readNotification(notificationId);
    }
  }, [isRead, notificationId, readNotification]);

  const stripeColor = useMemo(() => {
    if (isHSEDesign) return '#146DEE'
    if (isDvaDesign) return '#0C32EF'
    if (isCGRAVE) return 'rgb(255, 0, 255)'
    if (isDafes) return '#E75728'
    if (isGeograffee) return '#A4B54D'
    if (isGreenAward) return '#89B644'
    if (isJhonata) return '#f1db63'
    return '#F00'
  }, [])

  const isScrolledIntoView = useCallback(() => {
    const scrollContainer = document.querySelector('#notification-dropdown:not(.dropdown-element-popup):last-child');
    if (ref.current && scrollContainer) {
      //@ts-ignore
      const rect = ref.current.getBoundingClientRect();
      const elemTop = rect.top;
      const elemBottom = rect.bottom;
      const containerRect = scrollContainer.getBoundingClientRect();

      const isVisible = (elemTop >= 0) && (elemBottom <= containerRect.bottom);
      if (isVisible && !isRead) {
        setIsReadLocally(true)
        readNotification(notificationId);
      }
    }

  }, [isRead]);

  useEffect(() => {
    if (!isRead) {
      const scrollContainer = document.querySelector('#notification-dropdown:not(.dropdown-element-popup):last-child');
      scrollContainer?.addEventListener('scroll', isScrolledIntoView);

      return () => {
        scrollContainer?.removeEventListener('scroll', isScrolledIntoView)
      }
    }
  }, [isRead])

  return (
    <NotificationRoot
      //@ts-ignore
      ref={ref}
      className="notification-item"
      gy={8}
      isRead={isRead}
      isNew={isNew}
      onClick={handleClick}
      isHSEDesign={isHSEDesign}
      isImportantNots={isImportantNots}
      isCGRAVE={isCGRAVE}
      isGreenAward={isGreenAward}
      isSuperPuper={isSuperPuper}
      stripeColor={stripeColor}
    >
      <NotificationComponentController item={item}/>
    </NotificationRoot>
  )
}

export default NotificationListItem;


import {FC, useCallback, useEffect, useMemo, useRef, useState} from "react";
import 'moment/locale/ru'
import { NotificationRoot } from "./styles";
import { useNotificationContext } from "../../contexts/NotificationContext";
import {NotificationComponentController} from "./NotificationComponents/NotificationComponentController";
import {NotificationTypes} from "./const/const";
import { AppTester } from "supporting";
import { useToasts } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { Endpoints } from "@brg/api";

const NotificationListItem: FC<{ item: any }> = ({item}) => {

  const {
    notificationId,
    initiator: initiatorTop,
    isDelivered,
    actions
  } = item;

  const [ notificationData ] = actions;
  const { description, entityName } = notificationData;

  const { readNotification, readLocally } = useNotificationContext();
  const [isReadLocally, setIsReadLocally] = useState(isDelivered);
  const ref = useRef();

  const { error, info } = useToasts()
  const { t } = useTranslation()
  

  const firstLike = actions[0]?.likeInfo;
  const isPrint = actions[0]?.type === NotificationTypes.SEND_FILE;

  const isRead = isReadLocally || isDelivered || readLocally[notificationId];
  const isNew = useMemo(() =>(!isDelivered), [isDelivered])
  const isImportantNots = useMemo(() => (!firstLike && !isPrint), [firstLike, isPrint])
  const isHSEDesign = AppTester.isHSEDesign()
  const isCGRAVE = AppTester.isCGRAVE();
  const isSuperPuper = AppTester.isSuperPuper();
  const isDvaDesign = AppTester.isDvaDesign()
  const isGeograffee = AppTester.isGeograffee()
  const isGreenAward = AppTester.isGreenAward()
  const isDafes = AppTester.isGeoDafes()
  const isJhonata = AppTester.isJhonataNet()

  const handleDownload = (uploadUrl: string) => {
    info(t('print_project_save'))
    fetch(uploadUrl, { method: 'GET' })
        .then(resp => resp.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `${entityName}.pdf`
            document.body.appendChild(a);
            a.click();
            //@ts-ignore
            a = undefined
        })
        .catch((err: any) => {
            console.log('print_error_message', err)
            error(t('print_error_message'))
        })
  }

  const handleClick = useCallback(() => {
    if (isPrint) {
      const partLink = notificationData.textParts.find((part: any) => part.linkType === 'downloadFile')?.link
      const uploadUrl = `${Endpoints.files}/${partLink}`
      handleDownload(uploadUrl)
    }
    
    if (!isRead) {
      setIsReadLocally(true);
      readNotification(notificationId);
    }
  }, [isRead, notificationId, readNotification]);

  const stripeColor = useMemo(() => {
    if (isHSEDesign) return '#146DEE'
    if (isDvaDesign) return '#0C32EF'
    if (isCGRAVE) return 'rgb(255, 0, 255)'
    if (isDafes) return '#E75728'
    if (isGeograffee) return '#A4B54D'
    if (isGreenAward) return '#89B644'
    if (isJhonata) return '#f1db63'
    return '#F00'
  }, [])

  const isScrolledIntoView = useCallback(() => {
    const scrollContainer = document.querySelector('#notification-dropdown:not(.dropdown-element-popup):last-child');
    if (ref.current && scrollContainer) {
      //@ts-ignore
      const rect = ref.current.getBoundingClientRect();
      const elemTop = rect.top;
      const elemBottom = rect.bottom;
      const containerRect = scrollContainer.getBoundingClientRect();

      const isVisible = (elemTop >= 0) && (elemBottom <= containerRect.bottom);
      if (isVisible && !isRead) {
        setIsReadLocally(true)
        readNotification(notificationId);
      }
    }

  }, [isRead]);

  useEffect(() => {
    if (!isRead) {
      const scrollContainer = document.querySelector('#notification-dropdown:not(.dropdown-element-popup):last-child');
      scrollContainer?.addEventListener('scroll', isScrolledIntoView);

      return () => {
        scrollContainer?.removeEventListener('scroll', isScrolledIntoView)
      }
    }
  }, [isRead])

  return (
    <NotificationRoot
      //@ts-ignore
      ref={ref}
      className="notification-item"
      gy={8}
      isRead={isRead}
      isNew={isNew}
      onClick={handleClick}
      isHSEDesign={isHSEDesign}
      isImportantNots={isImportantNots}
      isCGRAVE={isCGRAVE}
      isGreenAward={isGreenAward}
      isSuperPuper={isSuperPuper}
      stripeColor={stripeColor}
    >
      <NotificationComponentController item={item}/>
    </NotificationRoot>
  )
}

export default NotificationListItem;


